<!-- start media-selector -->
<div class="media-selector-container">
  <div class="col">
    <div class="image-container" (click)="openUploader()">
      <div *ngIf="imgURL; else emptyImage" class="image-box"><img [src]="imgURL" class="checkered-bg" /> </div>
      <ng-template #emptyImage>
        <div class="empty-image"></div>
      </ng-template>

    </div>
    <div class="d-flex align-items-center mt-3">
      <div (click)="openUploader()" class="btn btn-select btn-primary">{{(!imgURL?'Select Image':'Change Image') | translate}}</div>
      <div *ngIf="!!imgURL && showClearButton" (click)="clearSelected()" class="btn btn-select btn-outline-danger">Clear
        Selected</div>
    </div>
  </div>
</div>
<!-- end media-selector -->
